export default {"src":"/_next/static/media/brand-logo.a026315b.svg","height":21,"width":182,"blurWidth":0,"blurHeight":0};